<ph-dialog [open]="open" size="md" heading="Update payable" (ph-close)="cancel()">
    <app-payable-update
        #payableDetailForm
        [payableId]="payableId"
        (formSubmitted)="onFormSubmitted()"
        (loadingStateChange)="onLoadingStateChange($event)">
    </app-payable-update>

    <ph-actions slot="footer">
        <ph-button variant="secondary" mode="filled" type="button" [disabled]="isLoading" (click)="cancel()">Cancel</ph-button>
        <ph-button type="button" [disabled]="isLoading" (click)="submit()">{{ isLoading ? 'Loading…' : 'Update payable' }}</ph-button>
    </ph-actions>
</ph-dialog>
